<template>
  <div class="commerce-home-order-summary main">
    <!-- <div v-if="showOrderSummary"> -->
    <div>
      <p class="order-summary">
        <!-- <span @click="toggleOrderSummary"> -->
        <span> <i class="fa fa-shopping-basket icon" />Orders </span>
        <i
          class="fa fa-external-link-alt fa-sm has-text-grey is-pulled-right"
          style="padding: 4px 0; opacity: 0.6"
          @click="goto('ecommerce')"
        />
      </p>
      <nav v-if="orders" class="level is-mobile">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Ongoing</p>
            <p class="title">{{ orders.orders_ongoing }}</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Today</p>
            <p class="title">{{ orders.orders_today }}</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Past 7 Days</p>
            <p class="title">{{ orders.orders_7_days }}</p>
          </div>
        </div>
        <!-- <span class="more link">More</span> -->
      </nav>
      <nav v-else class="level is-mobile">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Ongoing</p>
            <b-skeleton height="36px" />
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Today</p>
            <b-skeleton height="36px" />
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Past 7 Days</p>
            <b-skeleton height="36px" />
          </div>
        </div>
      </nav>
    </div>

    <!-- <div v-else style="padding: 4px 10px">
      <p style="margin-bottom: 8px" @click="toggleOrderSummary">
        See how easy it is to process an order
      </p>
      <div class="button is-fullwidth is-success is-outlined">
        Make a test order
        <i class="fa fa-chevron-right" style="margin-left: 6px" />
      </div>
    </div> -->
  </div>
</template>



<script>
// import MainBackButton from "@/components/MainBackButton";

export default {
  name: "CommerceHomeOrderSummary",
  components: {},
  data() {
    return {
      // showOrderSummary: true,
      orders: null,
    };
  },
  computed: {
    // showOrderSummary() {
    //   return this.business.is_active;
    // },
    business() {
      return this.$store.state.selectedBusiness;
    },
  },
  mounted() {
    this.updateData();
  },
  methods: {
    // toggleOrderSummary() {
    //   this.showOrderSummary = !this.showOrderSummary;
    // },
    updateData() {
      this.$store
        .dispatch("getCommerceStats", this.business.id)
        .then((res) => (this.orders = res.data))
        .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
.main {
  background-color: white;
  padding: 8px 0;
}
.order-summary {
  margin: 0 8px;
  margin-top: -4px;
  /* font-weight: 500; */
  /* color: grey; */
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.heading {
  font-weight: 500;
  color: grey;
  margin-bottom: 0;
  margin-top: 5px;
}
.more {
  position: absolute;
  right: 0;
}
</style>


<style>
.hours-modal td {
  padding: 5px;
}
</style>